export const PINTEREST_APP_ID = '13154';
export const PINTEREST_APP_CODE = 'pinterest';
